<template>
  <div id="container" ref="container" :class="`${containerClasses}`">
    <template 
      v-for="(item) in itemsToDisplay" 
    >
      <slot 
        :item="item"
      ></slot>
    </template>

    <template v-if="loading">
        <div class="dots">
          <div :style="`background-color: ${defaultLoadingColor}`"></div>
          <div :style="`background-color: ${defaultLoadingColor}`"></div>
          <div :style="`background-color: ${defaultLoadingColor}`"></div>
        </div>
    </template>

    <div v-show="((page !== items.length - 1) || !loading)" id="end-of-list" ref="end-of-list"/>

  </div>
</template>

<script>
  export default {
    name: 'LazyList',
    props:{
      data:{
        type: Array,
        default: () => [],
      },
      itemsPerRender:{
        type: Number,
        default: 3,
      },
      containerClasses:{
        type: String,
        default: '',
      },
      defaultLoading:{
        type: Boolean,
        default: true,
      },
      defaultLoadingColor:{
        type: String,
        default: '#18191A',
      },
    },
    created(){
      this.updateList();
      this.$watch('data', function () {
          this.updateList();
       }, {deep:true})
    },
    mounted(){
      this.$refs['container'].addEventListener('scroll', this.loadItems)
      this.loadItems()
    },
    beforeUnmount(){
      this.$refs['container'].removeEventListener('scroll', this.loadItems)
    },
    data(){
      return {
        items: [],
        page: 0, // page represents the index of last small array in the list
        loading: false,
        itemsToDisplay: [], // the list of items to be rendered
      }  
    },
    methods:{
      // set the list and update it when data changes
      updateList() {
        const chunckedArray = this.chunkArray(this.data,this.itemsPerRender) // chunkArray(data,itemsPerRender) to get array of small arrays
        this.items = chunckedArray
        this.itemsToDisplay =  chunckedArray[0]
       },

      chunkArray(data,itemsPerRender){
        const chunckedArray = []
        for(let i = 0; i < data.length; i += itemsPerRender){
          chunckedArray.push(data.slice(i, i + itemsPerRender))
        }
        return chunckedArray
      },
      
      // load more items when scrolling to the end of the list
      loadItems(){
        if(this.page === this.items.length - 1) return
        
        const element = this.$refs["end-of-list"] //this.endOfList;
        if(!element) return
        
        const position = element.getBoundingClientRect();

        // checking whether fully visible
        if((position.top >= 0 && position.bottom <= window.innerHeight  ) && !this.loading) {
          this.loading = true
          this.page++

          if (!Array.isArray(this.itemsToDisplay)) {
            this.loading = false
            return;
          }

            setTimeout(() => {
                this.itemsToDisplay = [...this.itemsToDisplay, ...this.items[this.page]]
                this.loading = false
                this.loadItems()
            }, 500);
        }
      },
    }
  }
</script>

<style>
.hidden{
  display: none;
}

/* List container style */
#container{
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  scrollbar-width: thin;
}
#end-of-list{
  height: 32px;
  width: 100%;
}
#loading-wrapper{
  width: 100%;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Loading style */
.dots {
  width: 3.5em;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
}
.dots div {
  width: 0.8em;
  height: 0.8em;
  border-radius: 50%;
  animation: fade 0.8s ease-in-out alternate infinite;
}
.dots div:nth-of-type(1) {
  animation-delay: -0.4s;
}
.dots div:nth-of-type(2) {
  animation-delay: -0.2s;
}
@keyframes fade {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@media(max-width: 480px) {
  .dots div {
    width: 0.7em;
    height: 0.7em;
  }
}
</style>